{
  "version": 1,
  "asset_id": "ea5b8845-832e-4536-ac31-e750745aa2bf",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/ea5b8845-832e-4536-ac31-e750745aa2bf/sleeve-to-bypass-first-view-es.png",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/ea5b8845-832e-4536-ac31-e750745aa2bf/sleeve-to-bypass-first-view-es.png",
  "original_filename": "sleeve-to-bypass-first-view-es.png",
  "size": 1018354,
  "content_type": "image/png",
  "created_at": "2026-10-05T12:33:55Z"
}
